import React from 'react';
import NumberFormat from 'react-number-format';

export class ChartOB extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showAll: false
		};

		this.changeShowAll = this.changeShowAll.bind(this);
	}

	changeShowAll() {
		if (this.state.showAll) {
			this.setState({
				showAll: false
			})
		} else {
			this.setState({
				showAll: true
			})
		}
	}

	render() {
		function compare(a, b) {
			if (parseInt(a.res_aktuell_proz) > parseInt(b.res_aktuell_proz) && a.bewerber_key !== "Sonstige") {
				return -1;
			}
			if (parseInt(a.res_aktuell_proz) < parseInt(b.res_aktuell_proz) || a.bewerber_key === "Sonstige") {
				return 1;
			}
			return 0;
		}
		let ordered_bewerber = [];
		let max = 0.0;
		for (let bewerber_key in this.props.ob_kandidaten) {
			if (
				(this.state.showAll && bewerber_key !== "Sonstige") || 
				(this.state.showAll === false && this.props.ob_kandidaten[bewerber_key].sonstige === false)
			) {
				if (this.props.bezirksdaten[bewerber_key + "_OB_proz"] > max) {
					max = this.props.bezirksdaten[bewerber_key + "_OB_proz"];
				}

				let color = this.props.parteien.Sonstige.Farbe
				if (this.props.ob_kandidaten[bewerber_key].partei in this.props.parteien) {
					color = this.props.parteien[this.props.ob_kandidaten[bewerber_key].partei].Farbe
				}

				let partei = "parteilos";
				if (bewerber_key === "Sonstige") {
					partei = null;
				}
				
				if (this.props.ob_kandidaten[bewerber_key].partei) {
					partei = this.props.ob_kandidaten[bewerber_key].partei
					if (partei in this.props.parteien) {
						partei = this.props.parteien[partei].Partei
					}
				}
				ordered_bewerber.push({
					"bewerber_key": bewerber_key, 
					"res_aktuell_proz": this.props.bezirksdaten[bewerber_key + "_OB_proz"],
					"res_aktuell_total": this.props.bezirksdaten[bewerber_key + "_OB_total"],
					"color": color,
					"partei": partei
				})

			}
		}

		ordered_bewerber = ordered_bewerber.sort(compare)
		if ('Gemeinden' in this.props.bezirksdaten && ["Duisburg", "Rheinisch-Bergischer Kreis", "Städteregion Aachen"].includes(this.props.bezirksdaten.Gemeinden)) {
			return (
					<div className="chart-parteien">
						<p className="bewerber"><i>Hier fand keine {this.props.bezirksdaten.Wahl == 'LR' ? 'Landratswahl' : 'Oberbürgermeisterwahl'} statt.</i>&nbsp;</p>
					</div>
				)
		}
		return (
			<>
				{this.props.showAbsolute && this.props.bezirksdaten.auszaehlung == 100 &&
					<div>
						<div className="chart-parteien">
							<div className="w100"></div>
							<div className="chart-parteien-percentage">
								<p>Stimmen</p>
							</div>
						</div>
					</div>
				}
				{ordered_bewerber.map((bewerber, index) => (
					<div className="chart-bewerber-group">
						{this.props.bezirksdaten.auszaehlung == 100
							?
								<>
									<p className="bewerber">{this.props.ob_kandidaten[bewerber.bewerber_key].name + (bewerber.partei ? " (" + bewerber.partei + ")" : "")}</p>
									<div className="chart-bewerber">
										<div className="" style={{"width": "100%", "height": "1rem"}}>
											<div className="bar rounded" style={{
												"width": (parseInt(bewerber.res_aktuell_proz) * 100 / max).toString() + "%", 
												"background": bewerber.color
											}}></div>
										</div>
										<div className="chart-parteien-percentage">
											<p>
												{this.props.showAbsolute
													? <NumberFormat value={bewerber.res_aktuell_total} decimalScale={0} fixedDecimalScale={true} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} />
													: <><NumberFormat value={bewerber.res_aktuell_proz} decimalScale={1} fixedDecimalScale={true} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} /> %</>
												}
											</p>
										</div>
									</div>
								</>
							:
								((index === 0 || this.props.preview) &&
									<>
										<p className="bewerber">{index === 0 ? <i>Ergebnis liegt noch nicht vor.</i> : " "}&nbsp;</p>
										<div className="chart-bewerber" style={{"width": "100%", "height": "1rem"}}></div>
									</>
								)
						}
					</div>
				))}
				{this.props.preview !== true && (this.props.bezirksdaten.auszaehlung == 100) && ordered_bewerber.length > 4 &&
					<button className="link text-center w100" onClick={this.changeShowAll} >
						{this.state.showAll
							? <><span>Weniger anzeigen</span><span className="turn-90deg" style={{"margin-left": "7px"}}>❯</span></>
							: <><span>Alle Kandidaten anzeigen</span><span className="turn90deg" style={{"margin-left": "7px"}}>❯</span></>

						}
					</button>
				}
			</>
		)
	}
}